// src/components/Widgets/CostWidget.jsx
import React from "react";
import PropTypes from "prop-types";
import WidgetHeader from "../Common/WidgetHeader";
import { useTheme } from "../../core/theme/ThemeProvider";

// Inline mini-estimator (our new Cost Mixer)
import CostMixerWidget from "./CostMixerWidget";

export default function CostWidget({
  onCreateNew,        // () => void
  onManageProducts,   // () => void
  backTo = "/dashboard",
}) {
  const canCreate = typeof onCreateNew === "function";
  const canManage = typeof onManageProducts === "function";
  const { mode } = useTheme();
  const primaryBtn =
    "w-full px-3 py-2 rounded-lg text-sm sm:text-base font-semibold transition bg-[var(--mudo-primary)] text-[var(--mudo-onPrimary,#0b0b0b)] hover:brightness-110 disabled:opacity-60 disabled:cursor-not-allowed active:scale-[0.99]";
  const secondaryBtn =
    mode === "dark"
      ? "w-full px-3 py-2 rounded-lg text-sm sm:text-base font-semibold transition border border-white/20 bg-white/5 text-white hover:bg-white/10 disabled:opacity-60 disabled:cursor-not-allowed active:scale-[0.99]"
      : "w-full px-3 py-2 rounded-lg text-sm sm:text-base font-semibold transition border border-black/15 bg-black/5 text-black hover:bg-black/10 disabled:opacity-60 disabled:cursor-not-allowed active:scale-[0.99]";

  return (
    <div className="h-full w-full text-white">
      <div className="rounded-lg p-4 bg-slate-900/60 border border-white/10 h-full">
        <WidgetHeader title="Cost Planner" to={backTo} />

        {/* Primary actions remain */}
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
          <button
            type="button"
            onClick={canCreate ? onCreateNew : undefined}
            disabled={!canCreate}
            aria-disabled={!canCreate}
            className={primaryBtn}
          >
            + Add New
          </button>

          <button
            type="button"
            onClick={canManage ? onManageProducts : undefined}
            disabled={!canManage}
            aria-disabled={!canManage}
            className={secondaryBtn}
          >
            Manage Products
          </button>
        </div>

        {/* Divider label */}
        <div className="mt-5 mb-2 text-xs uppercase tracking-wide text-slate-400">
          Quick Estimate
        </div>

        {/* Inline mini-calculator / estimator */}
        <CostMixerWidget
          onSave={(mix) => {
            if (canCreate) onCreateNew();
          }}
        />

        <div className="mt-3 text-xs text-slate-400">
          Tip: Add a product photo in the calculator so it shows up in your gallery.
        </div>
      </div>
    </div>
  );
}

CostWidget.propTypes = {
  onCreateNew: PropTypes.func,
  onManageProducts: PropTypes.func,
  backTo: PropTypes.string,
};
